module.exports = __webpack_public_path__ + "img/action-addContact.a6a668f1.svg";